import { createTheme } from "@mui/material/styles";

// Create a theme instance.
let theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
  },
  //Color properties
  palette: {
    primary: { main: "#E14084" },
    secondary: { main: "#3454FA" },
    custom: {
      raisinBlack: "#222222",
      white: "#FFFFFF",
      black: "#000000",
      eerieBlack: "#19132A",
    },
  },
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },
  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
    font: {
      montserrat: {
        fontFamily: ["Montserrat", "sans-serif"].join(", "),
      },
      openSans: {
        fontFamily: ["Open Sans", "sans-serif"].join(", "),
      },
    },
  },
});

const customTypography = {
  primaryBackground: {
    background:
      "linear-gradient(90.48deg, rgba(225, 64, 132, 0.1) 3.73%, rgba(52, 84, 250, 0.1) 53.09%, rgba(84, 181, 187, 0.1) 96.58%)",
    filter: "blur(234px)",
  },
  primaryBtn: {
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
  },
  disabledBtn: {
    background:
      "linear-gradient(90.52deg, #C4C4C4 4.01%, #C4C4C4 57.04%, #B0B0B0 103.77%)",
  },
  h1: {
    fontSize: "42px",
    fontWeight: 700,
    lineHeight: "54px",
  },
  h2: { fontSize: "36px", fontWeight: 700, lineHeight: "42px" },
  h3: { fontSize: "24px", fontWeight: 600, lineHeight: "32px" },
  h4: { fontSize: "20px", fontWeight: 400, lineHeight: "28px" },
};

theme = {
  ...theme,
  typography: {
    ...theme.typography,
    ...customTypography,
  },
};

export default theme;
